import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/shop/reservations";

export default {
  async getById(id) {
    return await axios
      .get(`${endpoint}/${id}`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async create(request) {
    return await axios
      .post(`${endpoint}/create`, request)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async uploadSignage(payload) {
    return await axios
      .post(`${endpoint}/signage`, payload)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async updateSignage(reservationId, payload) {
    return await axios
      .put(`${endpoint}/${reservationId}/signage`, payload)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async deleteSignage(reservationId) {
    return await axios
      .delete(`${endpoint}/${reservationId}/signage`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async cancel(request) {
    return await axios
      .put(`${endpoint}/cancel`, request)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async postFeedback(request) {
    return await axios
      .post(`${endpoint}/feedback`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async postNotes(request) {
    return await axios
      .post(`${endpoint}/note`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async repricing(reservationId) {
    return await axios
      .get(`${endpoint}/${reservationId}/repricing-detail`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getAvailableAncillaries(reservationId) {
    return await axios
      .get(`${endpoint}/${reservationId}/ancillaries`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async submitRepricing(reservationId, payload) {
    return await axios
      .put(`${endpoint}/${reservationId}/reprice`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getRepricingHistory(reservationId) {
    return await axios
      .get(`${endpoint}/${reservationId}/repricing-history`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getRepricingLog(reservationId, id) {
    return await axios
      .get(`${endpoint}/${reservationId}/repricing-log/${id}`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async closeReservation(reservationId) {
    return await axios
      .post(`${endpoint}/${reservationId}/close`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/shop/reservation/inquiryReservationService.js